// extracted by mini-css-extract-plugin
module.exports = {"main":"Layout_main__1cCIi","format":"Layout_format__7aivc"};